import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInjuryBrokenBone = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.92165 16.77C9.82769 16.6812 9.72743 16.5993 9.62165 16.525L11.6375 14.51C11.7126 14.4345 11.7672 14.3411 11.7962 14.2386C11.8251 14.1361 11.8275 14.028 11.8029 13.9243C11.7784 13.8207 11.7278 13.725 11.656 13.6464C11.5842 13.5678 11.4935 13.5088 11.3925 13.475L10.7175 13.25L10.0691 12.6017C9.95185 12.4848 9.79304 12.4192 9.62748 12.4192C9.46192 12.4192 9.30311 12.4848 9.18581 12.6017L7.44248 14.345C7.3677 14.2396 7.28584 14.1393 7.19748 14.045C6.88311 13.7299 6.49566 13.4975 6.06967 13.3685C5.64367 13.2395 5.19238 13.2179 4.75601 13.3056C4.31965 13.3934 3.91178 13.5877 3.56877 13.8714C3.22576 14.1551 2.95827 14.5192 2.79016 14.9313C2.62204 15.3434 2.55851 15.7908 2.60524 16.2334C2.65197 16.676 2.80751 17.1002 3.05798 17.4682C3.30846 17.8361 3.64609 18.1363 4.04077 18.3421C4.43545 18.5479 4.87491 18.6528 5.31998 18.6475C5.31487 19.0923 5.41989 19.5315 5.6257 19.926C5.8315 20.3204 6.13168 20.6577 6.4995 20.908C6.86731 21.1583 7.29133 21.3136 7.73376 21.3603C8.17618 21.4069 8.62328 21.3434 9.03519 21.1753C9.4471 21.0073 9.81104 20.7399 10.0946 20.3971C10.3781 20.0542 10.5724 19.6466 10.6601 19.2104C10.7479 18.7743 10.7264 18.3232 10.5975 17.8974C10.4687 17.4716 10.2365 17.0843 9.92165 16.77V16.77Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3334 5.80917C15.3603 5.93547 15.3962 6.05968 15.4409 6.18083L12.1901 7C12.0903 7.02538 11.9983 7.075 11.9223 7.14445C11.8462 7.21389 11.7885 7.30103 11.7542 7.39813C11.7199 7.49522 11.7101 7.59928 11.7257 7.70107C11.7412 7.80286 11.7817 7.89924 11.8434 7.98167L12.3142 8.6075L12.4701 9.45667C12.486 9.54139 12.5192 9.62192 12.5676 9.69324C12.6161 9.76455 12.6787 9.82513 12.7515 9.87118C12.8244 9.91724 12.906 9.94778 12.9912 9.96091C13.0764 9.97404 13.1634 9.96948 13.2467 9.9475L15.9967 9.21167C15.9978 9.34088 16.0084 9.46984 16.0284 9.5975C16.1079 10.0356 16.2946 10.4472 16.5719 10.7956C16.8491 11.144 17.2083 11.4183 17.6174 11.5941C18.0264 11.7699 18.4726 11.8418 18.9162 11.8032C19.3598 11.7646 19.7869 11.6169 20.1595 11.3731C20.5321 11.1293 20.8385 10.7971 21.0515 10.4061C21.2644 10.0151 21.3773 9.57743 21.38 9.13219C21.3827 8.68696 21.2752 8.24797 21.0669 7.85441C20.8587 7.46085 20.5563 7.12494 20.1867 6.87667C20.4433 6.51348 20.606 6.09248 20.6603 5.65118C20.7147 5.20988 20.6591 4.76198 20.4985 4.34738C20.3378 3.93278 20.0771 3.56435 19.7396 3.27492C19.402 2.98549 18.9981 2.78405 18.5639 2.68853C18.1296 2.59302 17.6785 2.60639 17.2506 2.72748C16.8228 2.84856 16.4315 3.07359 16.1118 3.38251C15.792 3.69144 15.5535 4.07467 15.4177 4.49806C15.2819 4.92145 15.253 5.37186 15.3334 5.80917V5.80917Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.96753 6.375L5.09253 4.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.46753 5.125L8.84253 3.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.34253 8.875H4.46753"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9675 17.625L18.8425 19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.2175 15.125H20.7175"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4675 18.875L13.8425 20.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInjuryBrokenBone.displayName = 'SvgInjuryBrokenBone';
export default SvgInjuryBrokenBone;
